<template>
  <div v-if="!loading">
    <p class="xPadding titleModal">
      {{ $t(`history.lastUpdated`) }}
    </p>
    <VTableHistory
      :headers="headers"
      :items="itemsForHistory"
    />
  </div>
</template>

<script>
import VTableHistory from '@/components/shared/content-views/VTableHistory';

export default {
    components: {
        VTableHistory,
    },
    props: {
        itemsForHistory: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            headers: [
                { text: this.$t('history.date'), value: 'date' },
                { text: this.$t('history.details'), value: 'details' },
                { text: this.$t('history.action'), value: 'action' },
            ],
            loading: false,
        };
    },
};
</script>

  <style scoped>
  .xPadding {
    padding: 0 6rem;
  }

  .titleModal {
    font-weight: bold;
    margin-bottom: 1rem;
  }

  @media screen and (max-width: 600px) {
    .xPadding {
      padding: 0;
    }
  }
  </style>
